import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f87c475")

_pushScopeId("data-v-3f87c475")
const _hoisted_1 = { class: "help-screen" }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = { class: "button-bar" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Close ")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "fal fa-angle-right" })
], -1)
const _hoisted_8 = { class: "modal-header" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h4", null, "Help Section:", -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, " -- slot name: body -- Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, " Section 1 "),
  /*#__PURE__*/_createVNode("li", null, " Section 2 "),
  /*#__PURE__*/_createVNode("li", null, " Section 3 ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1)
const _hoisted_14 = { class: "modal-footer row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", null, [
                  _createVNode("button", {
                    class: "btn btn-tertiary inv sml",
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('close')))
                  }, [
                    _hoisted_6,
                    _hoisted_7
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _hoisted_9
                ], {}, true)
              ]),
              _createVNode("div", _hoisted_10, [
                _renderSlot(_ctx.$slots, "body", {}, () => [
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13
                ], {}, true)
              ]),
              _createVNode("div", _hoisted_14, [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
              ])
            ])
          ])
        ])
      ]),
      _: 3
    })
  ]))
})